import React, { useEffect } from 'react';
import ReactCustomFlagSelect from 'react-custom-flag-select';
import { useDispatch, useSelector } from 'react-redux';
import { getCountryIcon } from '../helpers';
import { fundRaiserPageAction } from '../store/actions';

export function FlagsDropdown({ selectedOption, disableEdit = false, onChange }) {
    const dispatch = useDispatch();
    const countriesAndCurrencies = useSelector(state => state.countries.countries_with_currencies)

    const mapCurrencyOptions = () => {
        const currencyOptions = [];
        countriesAndCurrencies.map(currency => {
            currencyOptions.push({
                'id': currency.name,
                'symbol': currency.symbol_left,
                'currency': currency.currency_code,
                'currency_id': currency.currency_id,
                'db_id': currency.id,
                'name': currency.name,
                'displayText': currency.name,
                'locale': 'en-US',
                'value': currency.value,
                'country_name': currency.name,
                'code': currency.code,
                flag: (getCountryIcon(currency.code))
            })
        });
        return currencyOptions;
    }

    const getSelectedOption = () => {
        const optionExist = mapCurrencyOptions().find(option => option.id == selectedOption)
        return optionExist ? selectedOption : 'Pakistan'
    }

    const updateSelectedCurrency = (currencyName) => {
        const currency = mapCurrencyOptions().find(currency => currency.id == currencyName)
        onChange(currency);
    }

    useEffect(() => {
        if (!countriesAndCurrencies.length)
            dispatch(fundRaiserPageAction.getListOfCountriesWithCurrencies());
    }, [])

    return (
        countriesAndCurrencies && <ReactCustomFlagSelect
            value={getSelectedOption()}
            disabled={disableEdit}
            showSearch={true}
            showArrow={true}
            animate={true}
            optionList={mapCurrencyOptions()}
            classNameWrapper="currency-box-out" //Optional.[String].Default: "".
            classNameContainer="currency-box-inn" //Optional.[String].Default: "".
            classNameSelect="currency-box-inn-area" //Optional.[String].Default: "".
            classNameOptionListContainer="droop-down-listing-box" //Optional.[String].Default: "".
            classNameDropdownFlag="droop-down-flag" //Optional.[String].Default: "".
            classNameSelectDropdownFlag="droop-down-flag" //Optional.[String].Default: "".
            classNameSelectFlag="droop-down-flag" //Optional.[String].Default: "".
            classNameFlag="droop-down-flag" //Optional.[String].Default: "".
            classNameCustomFlag="droop-down-flag" //Optional.[String].Default: "".
            classNameFlagSelect="droop-down-flag" //Optional.[String].Default: "".
            classNameOptionListItem="droop-down-listing-option" //Optional.[String].Default: "".
            classNameDropdownIconOptionListItem={
                "arrow-area"
            }
            customStyleOptionListItem={
                {
                    outline: "none"
                }
            } //Optional.[Object].Default: {}.
            customStyleOptionListContainer={
                {
                    maxHeight: "200px",
                    overflow: "auto",
                    // minWidth: "230px",
                    width: "100%"
                }
            } //Optional.[Object].Default: {}.
            onChange={updateSelectedCurrency}
        />
    )
}